import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Linkify from 'linkifyjs/react';
import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import classes from './PostsTable.module.css';
import NoLogsSelected from 'assets/images/liefIcons/no-logs-selected.png';
import Spinner from 'components/UI/Spinner/Spinner';
import { getMediaThumb } from 'shared/util';
import {
  categoryImages,
  formatPostDateRangeForPostsTable,
  formatTimeRangeForPostsTableDisplay,
  getRgbFromColorName,
  sortLogNamesForDisplay,
  sortStringsWithinArrayOfObjects,
  truncateText,
  utcDateTimeToShortDateTime,
  utcToLocalDateTime,
} from 'shared/utility';
import * as actions from 'store/actions';
import { getUserProfileDetails } from 'store/thunks';

class PostsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeRowId: null,
      showLeftArrow: false,
      showRightArrow: null,
      showColumnsSelector: false,
      tableWidth: null,
      horizontalScrollColumn: 0,
    };
    this.columnSelector = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('mousedown', this.handleClickOutside);
    // In case where user returns to list view from post detail, scroll list to location of previous post
    const prevPostElementTop = document.getElementById(`post-${this.props.prevPostId}`)
      ? document.getElementById(`post-${this.props.prevPostId}`).offsetTop - 75
      : 0;
    // prevPostId is used to determine location on log view to scroll to when user is returning from a post detail.
    // It needs to be cleared after use to avoid side effects
    this.props.handleClearPrevPostId();
    // const scrollContainer = document.getElementById('posts-table');
    if (prevPostElementTop > 0 && this.props.reduxPageNumber && Number.isInteger(this.props.reduxPageNumber)) {
      // const pageNumber = parseInt(this.props.reduxPageNumber,10);
      this.props.handleCurrentPageUpdate(this.props.reduxPageNumber);
    }
  }

  componentDidUpdate(prevProps) {
    // if scrollToTopOfTable has been set to true - for reasons such as the user is view posts table and taps on Life Shared nav link or
    // filters/logs having been changed, scroll table up to top
    if (this.props.scrollToTopOfTable) {
      if (document.getElementById('posts-table')) document.getElementById('posts-table').scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
    if (this.props.columns !== prevProps.columns) {
      const postsTableWidth = document.getElementById('PostsTable') ? document.getElementById('PostsTable').clientWidth : null;
      if (postsTableWidth) this.setState({ tableWidth: postsTableWidth });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  fetchMorePosts = () => {
    this.props.fetchMorePosts();
  };

  handleKeyDown = (e) => {
    // handling left-right arrow clicks to navigate posts table
    const postsTable = document.getElementById('PostsTable');
    if (postsTable) {
      // left arrow
      if (e.keyCode === 37 && this.state.horizontalScrollColumn > 0) {
        this.handleArrowClick('left');
      } else if (e.keyCode === 39 && this.state.showRightArrow) {
        this.handleArrowClick('right');
      }
    }
  };

  handleTableScroll = () => {
    const tableContainer = document.getElementById('table-wrapper');
    if (tableContainer) {
      const showLeftArrow = tableContainer.scrollLeft > 0;
      const showRightArrow =
        tableContainer.scrollLeft + tableContainer.clientWidth < tableContainer.scrollWidth &&
        tableContainer.scrollWidth > tableContainer.clientWidth;
      this.setState({ showLeftArrow, showRightArrow });
    }
  };

  handleArrowClick = (direction) => {
    const tableContainer = document.getElementById('table-wrapper');
    const currentTableCell = document.getElementById('table-header-row').cells[this.state.horizontalScrollColumn];

    let updatedHorizontalScrollColumn = this.state.horizontalScrollColumn;
    let scrollPosition = 0;

    if (direction === 'right') {
      updatedHorizontalScrollColumn = this.state.horizontalScrollColumn + 1;
      scrollPosition = tableContainer.scrollLeft + currentTableCell.clientWidth;
    } else if (direction === 'left') {
      const leftTableCell = document.getElementById('table-header-row').cells[this.state.horizontalScrollColumn - 1];
      scrollPosition = leftTableCell.offsetLeft;
      updatedHorizontalScrollColumn = this.state.horizontalScrollColumn - 1;
    }
    tableContainer.scroll({ top: 0, left: scrollPosition, behavior: 'smooth' });
    this.setState({ horizontalScrollColumn: updatedHorizontalScrollColumn });
  };

  toggleColumnSelector = () => {
    this.setState({ showColumnsSelector: !this.state.showColumnsSelector });
  };

  handleClickOutside = (e) => {
    // if we click outside of the columns selector when it's open
    // close column selector
    if (this.columnSelector.current && !this.columnSelector.current.contains(e.target) && e.target.id !== 'column-selector-container') {
      if (this.state.showColumnsSelector === true) {
        this.setState({ showColumnsSelector: false });
      }
    }
  };

  render = () => {
    let postRows = null;
    const columnsList = [
      'Files',
      'Type',
      'Title',
      'DateStart',
      'User',
      'Logs',
      'Desc',
      'Contributors',
      'DatePostUpdated',
      'DateCreated',
      'Location',
      'Tags',
    ];
    let columnSelector = null;
    let columnOptions = [];
    // const contributors = ['contributor1', 'contributor2'];
    const tableHeadCells = columnsList.map((column) => {
      if (this.props.columns[column].selected) {
        return (
          <th
            className={
              this.props.selectedSortColumn === column ? [classes[`${column}Header`], classes.SortedHeader].join(' ') : classes[`${column}Header`]
            }
            onClick={() => {
              if (this.props.columns[column].sortable) this.props.handleSort(column);
            }}
            key={column}
          >
            {this.props.columns[column].name}
            {this.props.columns[column].sortable ? <FontAwesomeIcon icon="sort" className={classes.SortIcon} /> : null}
          </th>
        );
      }
      return null;
    });

    const tableContainer = document.getElementById('table-wrapper');

    const tableWrapperClasses = [classes.tableWrapper];

    const columnsSort = (columnsArray) => (a, b) => {
      if (a.selected && b.selected) {
        if (columnsArray[a] < columnsArray[b]) {
          return -1;
        }
        return 1;
      }
      if (a.selected && !b.selected) {
        return -1;
      }
      if (!a.selected && b.selected) {
        return 1;
      }
      if (columnsArray[a] < columnsArray[b]) {
        return -1;
      }
      return 1;
    };
    if (this.state.showColumnsSelector) {
      const columnObjects = columnsList.map((column) => this.props.columns[column]);
      const sortedColumns = columnObjects.sort(columnsSort(columnObjects));
      columnOptions = (
        <FlipMove duration={500}>
          {sortedColumns.map((column, i) => (
            <div
              key={sortedColumns[i].key}
              className={sortedColumns[i].selected ? [classes.ColumnItem, classes.Selected].join(' ') : classes.ColumnItem}
              onClick={() => this.props.handleColumnSelection(sortedColumns[i].key)}
            >
              <p>{sortedColumns[i].name}</p>
              {column.selected ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
            </div>
          ))}
        </FlipMove>
      );
      columnSelector = (
        <div ref={this.columnSelector} id="column-selector" className={classes.ColumnSelectorWindow}>
          <div className={classes.Columns}>{columnOptions}</div>
          <div onClick={this.props.restoreDefaultColumns} className={classes.Reset}>
            Reset to Default
          </div>
        </div>
      );
    }

    if (this.state.showRightArrow === null && tableContainer && tableContainer.scrollWidth > tableContainer.clientWidth)
      this.setState({ showRightArrow: true });

    if (this.props.posts) {
      postRows = this.props.posts.map((post, index) => {
        const postUserDetails = this.props.postingAs ? getUserProfileDetails(this.props.postingAs, post.Post.UserId) : {};
        const thumbURL = post.Files && post.Files.FileTop ? getMediaThumb(post.Files.FileTop) : null;
        let logs = post.Logs
          ? post.Logs.Logs.filter((log) => this.props.subscribedLogIds.includes(log.Id))
          : post.LogDetails && post.LogDetails.Logs
          ? post.LogDetails.Logs.Logs.filter((log) => this.props.subscribedLogIds.includes(log.Id))
          : [];
        logs = logs.length > 0 ? sortLogNamesForDisplay(logs).map((log) => log.Name) : [];
        const tags = [];
        if (post.Tags) {
          post.Tags.LocationTags.forEach((tag) => tags.push({ type: 'LocationTag', tag }));
          post.Tags.WhatTags.forEach((tag) => tags.push({ type: 'WhatTag', tag }));
          post.Tags.WhoTags.forEach((tag) => tags.push({ type: 'WhoTag', tag }));
        }
        const location2 = post.Post.Location2 ? (
          <span>
            {post.Post.Location2.split(',')[0]} <br /> {post.Post.Location2.replace(`${post.Post.Location2.split(',')[0]},`, '')}
          </span>
        ) : null;
        const categoryImage = post.Post.Type ? categoryImages.find((category) => category.name === post.Post.Type) : null;
        // const dateStart = post.Post.DateStartCalc ? post.Post.DateStartCalc : post.Post.DateStart.split(' ')[0];
        return (
          <tr
            key={`${index}-${post.Post.PostId}`}
            id={`post-${post.Post.PostId}`}
            className={this.state.activeRowId === post.Post.PostId ? [classes.PostRow, classes.Active].join(' ') : classes.PostRow}
            onMouseEnter={() => this.setState({ activeRowId: post.Post.PostId })}
            onMouseLeave={() => this.setState({ activeRowId: null })}
            onClick={() => this.props.clicked(post.Post.PostId, 'list')}
          >
            {this.props.columns.Files.selected ? (
              <td className={classes.Files}>
                <div className={classes.ThumbContainer}>
                  {thumbURL ? (
                    <img
                      // style={{ border: false ? '4px solid #23b7e5' : 'transparent' }}
                      style={{ border: 'transparent' }}
                      src={thumbURL}
                      alt={thumbURL}
                    />
                  ) : (
                    <div className={classes.DefaultImage} />
                  )}
                  {post.Post.FileCount > 1 ? (
                    <div className={classes.FileCount}>
                      <span>{post.Post.FileCount}</span>
                    </div>
                  ) : null}
                </div>
              </td>
            ) : null}
            {this.props.columns.Type.selected ? (
              <td className={classes.Type}>
                <categoryImage.image alt={categoryImage.name} />
              </td>
            ) : null}
            {this.props.columns.Title.selected ? (
              <td className={classes.Title}>
                <p>{truncateText(post.Post.Name, 125)}</p>
                {!post.MyHistory || !post.MyHistory.LastViewed ? <FontAwesomeIcon className={classes.UnseenFlag} icon="circle" /> : null}
              </td>
            ) : null}
            {this.props.columns.DateStart.selected ? (
              <td className={classes.DateStart}>
                <p>
                  {formatPostDateRangeForPostsTable(post.Post.DateStartCalc, post.Post.DateEndCalc)} <br />{' '}
                  {formatTimeRangeForPostsTableDisplay(post.Post.TimeStartCalc, post.Post.TimeEndCalc, post.Post.Ongoing)}
                </p>
              </td>
            ) : null}
            {this.props.columns.User.selected ? (
              <td className={classes.User}>
                <div>
                  <div
                    style={{ color: postUserDetails.Color ? getRgbFromColorName(postUserDetails.Color) : 'rgb(108 162 183)' }}
                    className={classes.Author}
                  >
                    {`${postUserDetails.FirstName} ${postUserDetails.LastName}`}
                  </div>
                </div>
              </td>
            ) : null}
            {this.props.columns.Logs.selected ? (
              <td className={classes.Logs}>
                {logs.map((logName) => (
                  <p key={logName}>{logName}</p>
                ))}
              </td>
            ) : null}
            {this.props.columns.Desc.selected ? (
              <td className={classes.Desc}>
                <Linkify tagName="p">{truncateText(post.Post.Desc, 138)}</Linkify>
              </td>
            ) : null}
            {this.props.columns.Contributors.selected ? (
              <td className={classes.Contributors}>
                <div className={classes.TagsContainer}>
                  {post.CommentUserIds && post.CommentUserIds.length > 0
                    ? post.CommentUserIds.map((commentUserId) => {
                        if (this.props.users.find((user) => user.UserId === commentUserId)) {
                          const contributor = this.props.users.find((user) => user.UserId === commentUserId);
                          return (
                            <p
                              style={{ color: contributor.Color ? getRgbFromColorName(contributor.Color) : 'rgb(108 162 183)' }}
                              key={commentUserId}
                              className={classes.Contributor}
                            >
                              {`${contributor.FirstName} ${contributor.LastName}`}{' '}
                            </p>
                          );
                        }
                        return null;
                      })
                    : ''}
                </div>
              </td>
            ) : null}
            {this.props.columns.DatePostUpdated.selected ? (
              <td className={classes.DateModified}>
                <p>{utcDateTimeToShortDateTime(utcToLocalDateTime(post.Post.DatePostUpdated))}</p>
              </td>
            ) : null}
            {this.props.columns.DateCreated.selected ? (
              <td className={classes.DateAdded}>
                <p>{utcDateTimeToShortDateTime(utcToLocalDateTime(post.Post.DateCreated))}</p>
              </td>
            ) : null}
            {this.props.columns.Location.selected ? (
              <td className={classes.Location}>
                <p>
                  {post.Post.Location ? post.Post.Location : null}
                  {post.Post.Location && post.Post.Location2 ? <br /> : null} {location2}
                </p>
              </td>
            ) : null}
            {this.props.columns.Tags.selected ? (
              <td className={classes.Tags}>
                <div className={classes.TagsContainer}>
                  {sortStringsWithinArrayOfObjects(tags, 'tag', 'asc').map((tag, i) => (
                    <span key={`${tag.type}-${i}`} className={classes[tag.type]}>
                      {tag.tag}
                      {i < tags.length - 1 ? ', ' : ''}{' '}
                    </span>
                  ))}
                </div>
              </td>
            ) : null}
          </tr>
        );
      });
    }
    const selectedColumnKeys = [];
    Object.keys(this.props.columns).forEach((columnKey) => {
      if (this.props.columns[columnKey].selected) selectedColumnKeys.push(columnKey);
    });
    let postsTable = (
      <table id="PostsTable" className={classes.PostsTable}>
        <thead>
          <tr id="table-header-row">{tableHeadCells}</tr>
        </thead>
        <tbody id="posts-table">
          {!this.props.initialPostsLoaded ? null : this.props.posts.length > 0 ? (
            <InfiniteScroll
              element="tbody"
              dataLength={this.props.posts.length}
              scrollableTarget="posts-table"
              next={this.fetchMorePosts}
              hasMore={this.props.loading ? true : this.props.posts.length < this.props.postCount}
              loader={
                <div style={{ display: 'flex' }}>
                  <Spinner lightColor small />
                  <h3>Loading More Posts</h3>
                </div>
              }
            >
              {postRows}
            </InfiniteScroll>
          ) : (
            <h3 className={classes.NoPostsAvailable}>This log doesn't yet have any posts</h3>
          )}
        </tbody>
      </table>
    );

    if (!this.props.loading && (selectedColumnKeys.length === 0 || this.props.filters.logIds.length === 0)) {
      postsTable = (
        <div className={classes.NoColumnsSelected}>
          <img src={NoLogsSelected} alt="please select logs" />
          <h1>{this.props.filters.logIds.length === 0 ? 'Select one or more logs.' : 'Select one or more table columns.'}</h1>
        </div>
      );
    }
    return (
      <div>
        <div
          style={{
            width:
              selectedColumnKeys.length === 0
                ? '1380px'
                : this.state.tableWidth
                ? `${this.state.tableWidth}px`
                : document.getElementById('PostsTable')
                ? `${document.getElementById('PostsTable').clientWidth}px`
                : '100%',
            margin: '0 auto 7px',
          }}
          className={classes.ColumnSelectorContainer}
        >
          <div className={classes.ColumnSelectorToggle} onClick={this.toggleColumnSelector} id="column-selector-container">
            Columns
            <FontAwesomeIcon icon="chevron-down" className={classes.ColumnSelectorIcon} />
          </div>
          {columnSelector}
        </div>
        <div className={classes.TableOuterContainer}>
          {this.state.showLeftArrow ? (
            <FontAwesomeIcon
              icon="chevron-left"
              onClick={() => this.handleArrowClick('left')}
              className={[classes.Arrow, classes.LeftArrow].join(' ')}
            />
          ) : null}
          <div id="table-wrapper" onScroll={this.handleTableScroll} className={tableWrapperClasses.join(' ')}>
            {postsTable}
          </div>
          {this.state.showRightArrow ? (
            <FontAwesomeIcon
              icon="chevron-right"
              id="right-arrow"
              onClick={() => this.handleArrowClick('right')}
              className={[classes.Arrow, classes.RightArrow].join(' ')}
            />
          ) : null}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    scrollToTopOfTable: state.app.scrollToTopOfChild,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateScrollToTopOfChild: (scrollToTop) => dispatch(actions.updateScrollToTopOfChild(scrollToTop)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostsTable);
